import { render, staticRenderFns } from "./IndexMap.vue?vue&type=template&id=e6871f26&scoped=true"
import script from "./IndexMap.vue?vue&type=script&lang=js"
export * from "./IndexMap.vue?vue&type=script&lang=js"
import style0 from "./IndexMap.vue?vue&type=style&index=0&id=e6871f26&prod&lang=less&scoped=true"
import style1 from "./IndexMap.vue?vue&type=style&index=1&id=e6871f26&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6871f26",
  null
  
)

export default component.exports